import React from 'react';
import PropTypes from 'prop-types';
import './styles.scss';

class PrivateNotes extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      show: false
    };
  }

  toggle = () => {
    this.setState(prevState => ({
      show: !prevState.show,
    }));
  };

  render() {
    const { title, icon, text } = this.props;
    const { show } = this.state;

    return (
      <div className='ui-list'>
        <div className={'icon'}> {icon} </div>
        <div className={'title'} onClick={this.toggle}>
          {title}
          <span
            className={
              !show ? 'float-right fa fa-fw fa-eye field-icon'
                : 'float-right fa fa-fw fa-eye-slash field-icon'}
          />
        </div>
          {!show && (
            <div
              style={{ marginTop: '.9rem', fontSize: '12px', textDecoration: 'underline', cursor: 'pointer' }}
              onClick={this.toggle}>
              Clicca per visualizzare le note venditore
            </div>
          )}

          {show &&
            <ul className="items">
              <li className="item" dangerouslySetInnerHTML={{ __html: text }} />
            </ul>
          }
      </div>
    );
  }
}

PrivateNotes.defaultProps = {
  icon: null,
};

PrivateNotes.propTypes = {
  title: PropTypes.string.isRequired,
  icon: PropTypes.any,
  text: PropTypes.any,
};

export default PrivateNotes;
